import { Grid2 } from "@mui/material";
import styles from "../CustomWidgets.module.scss";
import SpotlightCarousal from "../../../features/spotlight-carousal/components/SpotlightCarousal";

const SpotlightSectionGrid = () => (
  <Grid2 className={styles.gridContainer}>
    <Grid2 className={styles.spotlightCarousalWidgetBackground}>
      <SpotlightCarousal />
    </Grid2>
  </Grid2>
);

export default SpotlightSectionGrid;
